export const availableTimes = [
	{ 12: "09:00am", 24: "09:00" },
	{ 12: "09:30am", 24: "09:30" },
	{ 12: "10:00am", 24: "10:00" },
	{ 12: "10:30am", 24: "10:30" },
	{ 12: "11:00am", 24: "11:00" },
	{ 12: "11:30am", 24: "11:30" },
	{ 12: "12:00pm", 24: "12:00" },
	{ 12: "12:30pm", 24: "12:30" },
	{ 12: "01:00pm", 24: "13:00" },
	{ 12: "01:30pm", 24: "13:30" },
	{ 12: "02:00pm", 24: "14:00" },
	{ 12: "02:30pm", 24: "14:30" },
	{ 12: "03:00pm", 24: "15:00" },
	{ 12: "03:30pm", 24: "15:30" },
	{ 12: "04:00pm", 24: "16:00" },
	{ 12: "04:30pm", 24: "16:30" },
	{ 12: "05:00pm", 24: "17:00" },
	{ 12: "05:30pm", 24: "17:30" },
];
